import { render, staticRenderFns } from "./TopheaderComponent.vue?vue&type=template&id=13422c95&lang=pug&"
import script from "./TopheaderComponent.vue?vue&type=script&lang=js&"
export * from "./TopheaderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports